import "./css/App.css";
import "./css/schedule.css";

import TeamSchedule from "./modules/teamSchedule";
import DepthChartModule from "./modules/depthChart";
import { StandingsModule, PlayoffModule } from "./modules/leagueStandings";
import { Champions } from "./modules/pastChampions";
import { statSeason } from "./hooks/vars";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// TODO
// [ ] playoff picture
// [ ] league history

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 12 * 60 * 60 * 1000, // 12 hours
      cacheTime: 24 * 60 * 60 * 1000, // 24 hours
    },
  },
});

// Create the persister
const localStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: "REACT_QUERY_OFFLINE_CACHE", // Custom key name
  serialize: JSON.stringify,
  deserialize: JSON.parse,
});

// Set up persistence
persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 24 * 60 * 60 * 1000, // 24 hours
  buster: "1.0", // Increment this to invalidate old cache
});

function App() {
  //Team Search state
  //const [teamInput, setTeamInput] = React.useState("");

  return (
    <>
      {
        // old stuff
      }
      <QueryClientProvider client={queryClient}>
        <div className="appTitle">
          <h2>SPORTSBALLS {statSeason}</h2>
          
        </div>
        <div className="mainContainer">
          <TeamSchedule id={1} />
          <TeamSchedule id={2} />
          <StandingsModule />
          <PlayoffModule />
          <DepthChartModule />
          <Champions />
        </div>

        {/* DevTools (optional, only shows in development) */}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
